import { useState } from "react";
import { ProofStudioBrand } from "./ProofStudioBrand";
import { accountRequest } from "./account-api";
import { Button, Control } from "./components";
export function PublicWelcome() {
  const [sent, setSent] = useState(false),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  return (
    <div className="public-welcome">
      <header>
        <ProofStudioBrand />
        <nav aria-label="Public navigation">
          <a href="/help">Help</a>
          <a href="/docs">API & integrations</a>
          <a href="/login">Sign in</a>
        </nav>
      </header>
      <main>
        <section className="welcome-hero">
          <p className="eyebrow">PROOF STUDIO</p>
          <h1>Documents that work with your data.</h1>
          <p>
            Design variable documents, build forms and review accurate proofs in
            one workspace.
          </p>
          <a className="welcome-action" href="#request-access">
            Request access
          </a>
          <a href="/login">Open your workspace</a>
        </section>
        <section className="welcome-features" aria-label="What you can do">
          <article>
            <h2>Design & personalize</h2>
            <p>
              Combine editable layouts, variables, conditional content and
              managed fonts.
            </p>
          </article>
          <article>
            <h2>Collect & proof</h2>
            <p>
              Build forms, review changes and generate documents from your
              project data.
            </p>
          </article>
          <article>
            <h2>Connect your workflow</h2>
            <p>
              Embed forms and project tools or connect through the public API.
            </p>
            <a href="/docs">Explore integrations</a>
          </article>
        </section>
        <section id="request-access" className="welcome-request">
          <h2>Request access</h2>
          <p>
            Tell us about your team. An administrator will review your request
            and arrange your account invitation.
          </p>
          {sent ? (
            <p role="status">
              Your request has been received. We will contact you about access.
            </p>
          ) : (
            <form
              className="account-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const data = new FormData(e.currentTarget);
                setBusy(true);
                setError("");
                try {
                  await accountRequest(
                    "/access-requests",
                    Object.fromEntries(data),
                  );
                  setSent(true);
                } catch {
                  setError(
                    "We could not save your request. Please try again shortly.",
                  );
                } finally {
                  setBusy(false);
                }
              }}
            >
              <Control label="Your name">
                <input
                  name="name"
                  required
                  maxLength={200}
                  autoComplete="name"
                />
              </Control>
              <Control label="Work email">
                <input
                  name="email"
                  type="email"
                  required
                  maxLength={254}
                  autoComplete="email"
                />
              </Control>
              <Control label="Company">
                <input
                  name="company"
                  required
                  maxLength={200}
                  autoComplete="organization"
                />
              </Control>
              <Control label="What would you like to create?">
                <textarea name="message" maxLength={4000} />
              </Control>
              <div className="request-honeypot" aria-hidden="true">
                <label>
                  Website
                  <input name="website" tabIndex={-1} autoComplete="off" />
                </label>
              </div>
              {error && <p role="alert">{error}</p>}
              <Button kind="primary" type="submit" disabled={busy}>
                {busy ? "Sending request…" : "Send access request"}
              </Button>
            </form>
          )}
        </section>
      </main>
      <footer>
        <a href="/help">Public help</a>
        <a href="/docs/scalar">API reference</a>
      </footer>
    </div>
  );
}
